import { APP_CONFIG } from '../../constants/appConfig';

export class ApiError extends Error {
  constructor(message, status, payload) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

async function parseResponse(response) {
  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return response.json();
  }

  const text = await response.text();
  return text || null;
}

function buildUrl(path, baseUrl = APP_CONFIG.apiBaseUrl) {
  return `${baseUrl}${path}`;
}

function buildRequestInit(options) {
  const { token, body, headers, ...restOptions } = options;

  return {
    ...restOptions,
    headers: {
      ...(body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  };
}

function canRetryWithIpv4(baseUrl) {
  return typeof baseUrl === 'string' && baseUrl.includes('localhost');
}

export async function apiRequest(path, options = {}) {
  const requestInit = buildRequestInit(options);
  const primaryUrl = buildUrl(path);
  const fallbackBaseUrl = APP_CONFIG.apiBaseUrl.replace('localhost', '127.0.0.1');

  let response;

  try {
    response = await fetch(primaryUrl, requestInit);
  } catch (error) {
    if (canRetryWithIpv4(APP_CONFIG.apiBaseUrl)) {
      try {
        response = await fetch(buildUrl(path, fallbackBaseUrl), requestInit);
      } catch (retryError) {
        throw new ApiError(
          'No pudimos conectar con la tienda. Comprueba tu conexión e inténtalo de nuevo.',
          0,
          { cause: retryError?.message || retryError },
        );
      }
    } else {
      throw new ApiError(
        'No pudimos conectar con la tienda. Comprueba tu conexión e inténtalo de nuevo.',
        0,
        { cause: error?.message || error },
      );
    }
  }

  const payload = await parseResponse(response);

  if (!response.ok) {
    const message =
      payload?.message ||
      payload?.error ||
      `Error HTTP ${response.status}`;

    throw new ApiError(message, response.status, payload);
  }

  return payload;
}